import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValues = {
  code: '',
  description: '',
  officeNumber: '',
  istat: '',
  province: '',
  anpr: false,
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageInstitutionInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageInstitutionInitializer.displayName = 'Page institution initializer component';

export default PageInstitutionInitializer;
